import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoSvg from './LogoSvg';
import '../components.css';

const PrivacyTerms = ({ authUser, onLogout }) => {
  const navigate = useNavigate();

  const handleAdminClick = () => {
    navigate('/admin');
  };

  const handleLogout = () => {
    onLogout();
  };

  return (
    <div className="full-height-container" style={{ backgroundColor: '#ffffff', color: '#333333' }}>
      {/* Header */}
      <header className="site-header site-header-style">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light py-3">
            <div className="d-flex justify-content-between align-items-center w-100">
              <div 
                onClick={() => navigate('/')} 
                style={{ cursor: 'pointer', display: 'inline-block' }}
                title="Go to Landing Page"
              >
                <LogoSvg 
                  alt="Arkansas Electric Cooperatives, Inc." 
                  className="logo-large"
                />
              </div>
              <div className="d-flex align-items-center gap-3">
                <nav className="d-none d-lg-flex">
                  <ul className="navbar-nav me-4" style={{ display: 'none' }}>
                    <li className="nav-item mx-2">
                      <a className="nav-link text-dark" href="#home">Home</a>
                    </li>
                    <li className="nav-item mx-2">
                      <a className="nav-link text-dark" href="#about">About Us</a>
                    </li>
                    <li className="nav-item mx-2">
                      <a className="nav-link text-dark" href="#services">Services</a>
                    </li>
                    <li className="nav-item mx-2">
                      <a className="nav-link text-dark" href="#news">News</a>
                    </li>
                    <li className="nav-item mx-2">
                      <a className="nav-link text-dark" href="#contact">Contact</a>
                    </li>
                  </ul>
                </nav>
                
                {/* Show Admin Panel button only for admin users */}
                {authUser && authUser.is_admin && (
                  <button 
                    className="btn btn-success px-4 py-2 btn-success-custom"
                    onClick={handleAdminClick}
                  >
                    Admin Panel
                  </button>
                )}
                
                {/* Logout button for all authenticated users */}
                {authUser && (
                  <button 
                    className="btn btn-outline-secondary px-4 py-2"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                )}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Content Section */}
      <section className="section-primary" style={{ minHeight: '60vh', padding: '4rem 0' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h1 className="text-center mb-5">Privacy Policy & Terms of Use</h1>
              
              <div className="content-section mb-4">
                <h3>Access and Eligibility</h3>
                <p>
                  This site is a private information tool provided exclusively for employees and authorized representatives of Arkansas Electric Cooperative Corporation ("AECC"). Access is restricted to individuals expressly invited by AECC. By using this site, you confirm that you are an authorized AECC employee or representative and agree to abide by these terms.
                </p>
              </div>

              <div className="content-section mb-4">
                <h3>Use of Content</h3>
                <p>
                  The content provided through this site, including news articles, summaries, and analysis, is intended for informational purposes only. While efforts are made to ensure accuracy and relevance, AECC and its partners do not guarantee the completeness, accuracy, or timeliness of the information. This site does not provide legal, financial, or operational advice, and decisions should not be made based solely on the content presented.
                </p>
              </div>

              <div className="content-section mb-4">
                <h3>Confidentiality and Restrictions</h3>
                <p>
                  You agree not to share, distribute, or reproduce content from this site outside of AECC or its designated representatives without prior authorization. Unauthorized access, use, or disclosure may result in disciplinary action and/or legal liability.
                </p>
              </div>

              <div className="content-section mb-4">
                <h3>Privacy and Data Collection</h3>
                <p>
                  This site may collect limited technical information, such as login activity and usage patterns, for the purpose of maintaining security, improving functionality, and ensuring compliance with AECC's internal policies. Personal information voluntarily submitted (such as contact details for notifications) will be used solely for internal AECC purposes and will not be sold or shared with outside parties, except as required by law.
                </p>
              </div>

              <div className="content-section mb-4">
                <h3>Limitation of Liability</h3>
                <p>
                  AECC, its partners, and service providers are not responsible for any losses or damages arising from use of this site or reliance on its content. Use of the site is at your own discretion and risk.
                </p>
              </div>

              <div className="content-section mb-4">
                <h3>Amendments</h3>
                <p>
                  AECC reserves the right to update or modify these Terms of Use and Privacy Policy at any time without prior notice. Continued use of the site constitutes acceptance of the most current version.
                </p>
              </div>

              <div className="text-center mt-5">
                <button 
                  className="read-full-article-btn"
                  onClick={() => navigate('/')}
                >
                  Return to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyTerms; 